import { faUser } from "@fortawesome/free-solid-svg-icons";
import { isPositiveNumber } from "et3-type-guards";
import React from "react";
import i18n from "../../../../constants/i18n";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getAIDescriptionsStore from "../../../../stores/user-store/ai-descriptions-store";

const UserAIDescriptionsForm = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"number"}
        icon={faUser}
        label={i18n.get("USER_ID")}
        placeHolder={i18n.get("USER_ID")}
        value={getAIDescriptionsStore().userIDInput.get()}
        onChoose={(value: number) =>
          getAIDescriptionsStore().userIDInput.set(value)
        }
        onBlur={() => {}}
        onEnter={() => {
          getAIDescriptionsStore().getUserAIDescriptions();
        }}
        style={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isPositiveNumber(getAIDescriptionsStore().userIDInput.get())}
        onClick={async () => {
          getAIDescriptionsStore().getUserAIDescriptions();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default UserAIDescriptionsForm;
